"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ValidationException;
require("core-js/modules/es.function.name.js");
function ValidationException(errors, moreThanWeeks) {
  this.name = 'ValidationException';
  this.errors = errors;
  this.moreThanWeeks = moreThanWeeks;
  this.message = JSON.stringify(errors);
  this.stack = new Error().stack;
}
ValidationException.constructor = ValidationException;